import { useCallback } from 'react';
import { Environment } from '~/engine/data/Environment';

/**
 * Stable callback around {@link Environment.triggerContourLayerUpdate}
 * for operation panels, which hold the environment as a nullable Recoil
 * value. With no environment there are no views to repaint, so the
 * callback is a no-op — a panel must not fall back to the ViewManager
 * static for that case.
 */
export function useContourLayerViewUpdate(
    environment: Environment | null
): () => void {
    return useCallback(
        () => environment?.triggerContourLayerUpdate(),
        [environment]
    );
}
